import * as React from 'react';
import { BrandProvider } from '@shared-ui/brand-context';
import { SystemEvent, SystemEventLevel } from 'bernie-logger';
import { ClientLogger } from 'bernie-client';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol */

var __assign = function () {
  __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
var LOAD_BRAND_FAILED = new SystemEvent(SystemEventLevel.ERROR, 'LOAD_BRAND_FAILED');
var loadBrandData = function (logger, brand) {
  return __awaiter(void 0, void 0, void 0, function () {
    var brandData, loader, err_1;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          brandData = {};
          _a.label = 1;
        case 1:
          _a.trys.push([1, 4,, 5]);
          loader = require("".concat(process.env.BERNIE_brands__client, "/loader"));
          if (!!document.querySelector('#brand-icons')) return [3 /*break*/, 3];
          return [4 /*yield*/, loader.loadBrandData(brand)];
        case 2:
          brandData = _a.sent();
          _a.label = 3;
        case 3:
          return [3 /*break*/, 5];
        case 4:
          err_1 = _a.sent();
          // do nothing
          logger.logEvent(LOAD_BRAND_FAILED, err_1);
          return [3 /*break*/, 5];
        case 5:
          return [2 /*return*/, brandData];
      }
    });
  });
};
var getBrandConfiguration = function (brandData) {
  var iconSet = brandData && brandData.iconData || null;
  var getIconData = function (name) {
    if (!iconSet || !iconSet.icons[name] && !iconSet.nameMapping[name]) {
      return null;
    }
    return iconSet.nameMapping[name] || name;
  };
  var getIconPath = function (name) {
    var iconDataVal = getIconData(name);
    if (!iconDataVal) {
      return null;
    }
    return iconSet.icons[iconDataVal].data;
  };
  var getIcon = function (name) {
    var iconDataVal = getIconData(name);
    if (!iconDataVal) {
      return null;
    }
    // eslint-disable-next-line react/display-name
    return function (props) {
      var innerSvgProps = __assign({
        dangerouslySetInnerHTML: {
          __html: iconSet.icons[iconDataVal].data
        }
      }, props);
      return React.createElement("svg", __assign({}, innerSvgProps));
    };
  };
  return {
    getIcon: getIcon,
    getIconPath: getIconPath
  };
};
function EgdsStylesPlugin() {
  return {
    name: 'egds-styles',
    onBrowserWrapRootElement: function (pluginContext, next) {
      return __awaiter(this, void 0, void 0, function () {
        var logger, setRootElement, getAppData, context, brandConfig, brandData;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              logger = ClientLogger.getLoggerWithIdentifier('bernie.client.brand-loader');
              setRootElement = pluginContext.setRootElement, getAppData = pluginContext.getAppData;
              context = getAppData().context;
              return [4 /*yield*/, loadBrandData(logger, context === null || context === void 0 ? void 0 : context.site.brand)];
            case 1:
              brandConfig = _a.sent();
              brandData = getBrandConfiguration(brandConfig);
              setRootElement(function (RootElement) {
                return function (props) {
                  return React.createElement(BrandProvider, {
                    config: brandData
                  }, React.createElement(RootElement, null, props.children));
                };
              });
              return [2 /*return*/, next(pluginContext)];
          }
        });
      });
    }
  };
}
export { EgdsStylesPlugin as default };